import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/GroupNodeContent/GroupNodeContent.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.function.name.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { Folder, FolderDynamicGenerated, FolderGrouping, FolderGroupingChild, FolderRoot, FolderShared, NodeMoreActionButton, WithSumIcon } from '@gmini/ui-kit';
import { mergeReactRefs } from '@gmini/utils/lib/mergeReactRefs';
import { useHover, useWithDelay } from '@gmini/utils';
import { useDragLayer, useDrop } from 'react-dnd';
import { NodeDndManualSortButton } from "../../NodeDndManualSortButton";
import { FolderFilterIcon } from "../../../../components";
import { getNode } from "../../../../classifier-service";
import { isGroupType } from "../../../../classifier-service/adapters";
import { useDynamicGroupsConditions, useNodes, useTree } from "../../TreeContext";
import { DndOverNodeContent } from "../../../Common/UI/DndOverNodeContent";
import { OverNodeBorder } from "../../../Common/UI/DndOverNodeContent.styled";
import { getGroupPendingKey } from "../../model/pendingModel";
import { DndType } from "../../../DragNDrop/dndType";
import { NodeLayout } from "../../NodeLayout";
import { NodeCheckbox } from "../../NodeCheckbox";
import { useNodeCtxMenu } from "../../TreeContextMenu/ctx";
import { FormNodeContent } from "../FormNodeContent";
import { useDragWithBeginDelay } from "../../../DragNDrop/useDragWithBeginDelay";
import { useReadonlyMode } from "../../../../hooks";
import { getStyle } from "../../../Common/getStyle";
import { isHighlightedInSearch } from "../../../Common/isHighlightedInSearch";
import { findFlatChildren } from "../../utils";
import { useOrderingNodeDnd } from "../dndOrdering";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GroupNodeContent = function GroupNodeContent(_ref) {
  var _node$source;

  var node = _ref.node,
      onClickNode = _ref.onClickNode,
      path = _ref.path,
      onDroppedToGroup = _ref.onDroppedToGroup,
      onDroppedBefore = _ref.onDroppedBefore,
      onDroppedAfter = _ref.onDroppedAfter,
      canDropAfter = _ref.canDropAfter,
      canDropBefore = _ref.canDropBefore,
      RenderNodeLayout = _ref.renderNodeLayout,
      checkbox = _ref.checkbox,
      onCheckedNode = _ref.onCheckedNode,
      onDoubleClickNode = _ref.onDoubleClickNode,
      isExpanded = _ref.isExpanded,
      inEdit = _ref.inEdit,
      onCancelEditing = _ref.onCancelEditing,
      onSubmitEditing = _ref.onSubmitEditing,
      canDropToGroup = _ref.canDropToGroup,
      inSearch = _ref.inSearch,
      onPending = _ref.onPending,
      isSelected = _ref.isSelected,
      dynamicMode = _ref.dynamicMode,
      onExpandClick = _ref.onExpandClick,
      isSpecialNode = _ref.isSpecialNode,
      highlighted = _ref.highlighted,
      treeItem = _ref.treeItem,
      readonly = _ref.readonly;

  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      someoneDragging: monitor.isDragging()
    };
  }),
      someoneDragging = _useDragLayer.someoneDragging;

  var _useNodeCtxMenu = useNodeCtxMenu({
    path: path
  }),
      onContextMenu = _useNodeCtxMenu.onContextMenu,
      open = _useNodeCtxMenu.open,
      onClickOpen = _useNodeCtxMenu.onClickOpen;

  var matched = inSearch.matched,
      fullMatch = inSearch.fullMatch;

  var _useHover = useHover(),
      onMouseLeave = _useHover.onMouseLeave,
      onMouseOver = _useHover.onMouseOver,
      hover = _useHover.hover;

  var _useReadonlyMode = useReadonlyMode(),
      readonlyMode = _useReadonlyMode.readonlyMode;

  var _useDrop = useDrop({
    // TODO вынести в пропсы в EditorTree
    accept: [DndType.FROM_OWN_CLASSIFIER, DndType.FROM_DEPENDENCIES],
    drop: function drop(_ref2) {
      var type = _ref2.type;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onDroppedToGroup({
        target: node,
        from: type
      });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    canDrop: function canDrop(_ref3) {
      var type = _ref3.type;
      return canDropToGroup({
        from: type,
        target: node
      });
    },
    collect: function collect(m) {
      return {
        isOver: m.isOver(),
        canDrop: m.canDrop()
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      isOver = _useDrop2$.isOver,
      canDrop = _useDrop2$.canDrop,
      dropRef = _useDrop2[1];

  var _useWithDelay = useWithDelay({
    hover: isOver
  }, {
    enterDelay: 400,
    leaveDelay: 200
  }),
      isOverWithDelay = _useWithDelay.hover;

  React.useEffect(function () {
    if (readonly) {
      return;
    }

    if (isOver) {
      var timeout = setTimeout(function () {
        if (!isExpanded) {
          onExpandClick === null || onExpandClick === void 0 ? void 0 : onExpandClick();
        }
      }, 500);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [isExpanded, isOver, onExpandClick, readonly]);

  var _useDragWithBeginDela = useDragWithBeginDelay({
    item: {
      type: DndType.FROM_OWN_CLASSIFIER
    },
    begin: function begin() {
      onCheckedNode(true);
    },
    collect: function collect(m) {
      return {
        isDragging: m.isDragging(),
        canDrag: m.canDrag()
      };
    },
    canDrag: !readonlyMode.enabled && !!node.parentGroupId && ((_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.relationType) !== 'Indirect'
  }),
      _useDragWithBeginDela2 = _slicedToArray(_useDragWithBeginDela, 3),
      isDragging = _useDragWithBeginDela2[0].isDragging,
      dragRef = _useDragWithBeginDela2[1],
      preview = _useDragWithBeginDela2[2];

  React.useEffect(function () {
    preview(getEmptyImage(), {
      captureDraggingState: false
    });
  }, [preview]);
  var expandable = 'total' in node && node.total > 0;

  var _isHighlightedInSearc = isHighlightedInSearch({
    matched: matched,
    fullMatch: fullMatch,
    isExpanded: isExpanded,
    highlighted: highlighted
  }),
      highlightedInSearch = _isHighlightedInSearc.highlightedInSearch;

  var style = getStyle({
    isSelected: isSelected,
    hover: hover || open,
    highlightedInSearch: highlightedInSearch,
    isDragging: isDragging,
    someoneDragging: someoneDragging,
    canDrop: canDrop,
    isOver: isOver
  });
  var deepness = path.length - 1; // TODO: оптимизация (будет часто перерисовываться каждый элемент в дереве при изменении данных)

  var dynamicConditionsMap = useDynamicGroupsConditions();
  var dynamicConditions = dynamicConditionsMap[node.parentClassifierId] || [];
  var tree = useTree();
  var nodes = useNodes();

  var hasChildGroupsWithConditions = function hasChildGroupsWithConditions() {
    var allChildren = findFlatChildren(tree, path);
    return allChildren.some(function (child) {
      if (isGroupType(child.ref.type)) {
        return dynamicConditions.some(function (cond) {
          return cond.sourceGroupId === child.ref.id;
        });
      }

      if (child.ref.type === 'DynamicGeneratedGroupNode') {
        var _childNode$source;

        var childNode = getNode(nodes, {
          type: 'DynamicGeneratedGroupNode',
          id: child.ref.id
        });
        return (childNode === null || childNode === void 0 ? void 0 : (_childNode$source = childNode.source) === null || _childNode$source === void 0 ? void 0 : _childNode$source.type) === 'UserClassifierGroup' && dynamicConditions.some(function (cond) {
          var _childNode$source2;

          return cond.sourceGroupId === ((_childNode$source2 = childNode.source) === null || _childNode$source2 === void 0 ? void 0 : _childNode$source2.id);
        });
      }
    });
  };

  var hasOwnDynamicConditions = function hasOwnDynamicConditions() {
    return dynamicConditions.some(function (cond) {
      return cond.sourceGroupId === node.id;
    });
  };

  var dynamicBlueColor = '#4C5ECF';
  var groupColor = dynamicMode ? dynamicBlueColor : '#353B60'; // Костыльное условие, для отрисовки группы как динамической, если у неё внутри есть виртуальный типоразмер

  var hasVirtualStandardSize = function hasVirtualStandardSize() {
    return Object.values(nodes.DynamicBaseGroupNode).some(function (_ref4) {
      var sourceGroupId = _ref4.sourceGroupId;
      return sourceGroupId === node.id;
    });
  };

  var hasGrouping = function hasGrouping() {
    return hasOwnDynamicConditions() || hasChildGroupsWithConditions() || hasVirtualStandardSize();
  };

  var icon = /*#__PURE__*/_jsx(Folder, {});

  if (!(dynamicMode && hasGrouping()) && node.filterCondition) {
    // Если на группе есть фильтр
    icon = /*#__PURE__*/_jsx(FolderFilterIcon, {});
  } else if (node.source) {
    // Если группа перенесена из другого классификатора
    icon = /*#__PURE__*/_jsx(FolderShared, {});
  } else if (hasOwnDynamicConditions()) {
    // Если на саму группу назначены условия группировки
    icon = /*#__PURE__*/_jsx(FolderGrouping, {
      color: groupColor
    });
  } else if (hasChildGroupsWithConditions()) {
    // Если на одну из дочерних групп (на любом уровне) назначены условия группировки
    icon = /*#__PURE__*/_jsx(FolderGroupingChild, {
      color: groupColor
    });
  } else if (dynamicMode && hasVirtualStandardSize()) {
    icon = /*#__PURE__*/_jsx(FolderDynamicGenerated, {
      color: dynamicBlueColor,
      opacity: 1
    });
  }

  var _useOrderingNodeDnd = useOrderingNodeDnd({
    node: node,
    onDroppedAfter: onDroppedAfter,
    onDroppedBefore: onDroppedBefore,
    canDropAfter: canDropAfter,
    canDropBefore: canDropBefore,
    path: path
  }),
      dragOrderingRef = _useOrderingNodeDnd.dragOrderingRef,
      dropOrderingRef = _useOrderingNodeDnd.dropOrderingRef,
      canDropOrdering = _useOrderingNodeDnd.canDropOrdering,
      isBottomOver = _useOrderingNodeDnd.isBottomOver,
      isTopOver = _useOrderingNodeDnd.isTopOver;

  var nodeLayoutProps = {
    ref: mergeReactRefs(dropRef, dragRef, dropOrderingRef),
    icon: icon,
    text: node.name,
    onClick: onClickNode,
    onDoubleClick: onDoubleClickNode,
    onExpand: onExpandClick,
    onMouseLeave: onMouseLeave,
    onMouseOver: onMouseOver,
    onContextMenu: onContextMenu,
    textStyle: {
      color: style.color
    },
    isExpanded: isExpanded,
    expandable: expandable,
    checkbox: /*#__PURE__*/_jsx(NodeCheckbox, _objectSpread(_objectSpread({}, checkbox), {}, {
      onChange: function onChange(_, value) {
        return onCheckedNode(value);
      }
    })),
    // TODO вынести наверх либо в функцию для избавления от копипасты
    deepness: deepness,
    style: _objectSpread({}, style),
    pending: onPending(getGroupPendingKey(node, dynamicMode)),
    //TODO pendingMap refactor,
    moreActionButton: !readonly ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NodeDndManualSortButton, {
        ref: dragOrderingRef,
        show: hover
      }), /*#__PURE__*/_jsx(NodeMoreActionButton, {
        show: hover || open,
        active: open,
        onClick: onClickOpen
      })]
    }) : null,
    hover: hover,
    overLayoutContent: /*#__PURE__*/_jsx(DndOverNodeContent, {
      deepness: deepness,
      isMiddleOver: canDrop ? isOver : isOverWithDelay,
      isTopOver: isTopOver,
      isBottomOver: isBottomOver,
      isDragging: isDragging,
      canDrop: canDrop,
      someoneDragging: someoneDragging,
      overContent: /*#__PURE__*/_jsx(OverNodeBorder, {}),
      canDropOrdering: canDropOrdering
    })
  };

  if (inEdit) {
    return /*#__PURE__*/_jsx(FormNodeContent, {
      initialValue: node.name,
      icon: //TODO опрокидывать коллбек для определения иконки
      isSpecialNode && /*#__PURE__*/_jsx(WithSumIcon, {
        icon: /*#__PURE__*/_jsx(FolderRoot, {})
      }),
      deepness: deepness,
      onCancel: onCancelEditing,
      onSubmit: function onSubmit(newName) {
        return onSubmitEditing(newName, node);
      }
    });
  }

  if (RenderNodeLayout) {
    return RenderNodeLayout({
      node: node,
      nodeLayoutProps: nodeLayoutProps,
      path: path,
      treeItem: treeItem
    });
  }

  return /*#__PURE__*/_jsx(NodeLayout, _objectSpread({}, nodeLayoutProps));
};